export default ".text{font-family:\"Heebo\",sans-serif;white-space:normal}.text--dark{color:#fff}";